import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";

const SignaturePad = ({ onEnd, sigCanvas, clearSignaturefrompagethree }) => {
    // const sigCanvas = useRef({});
    const [selectedColor, setSelectedColor] = useState("#000000");

    const clearSignature = () => {
        sigCanvas.current.clear();
        clearSignaturefrompagethree();
    };

    return (
        <div className="tw-w-full tw-bg-white tw-h-[472px] tw-border tw-rounded-xl  ">
            {/* Signature Pad */}
            <SignatureCanvas
                ref={sigCanvas}
                penColor={selectedColor}
                canvasProps={{
                    className: "tw-border-b tw-w-full tw-rounded-tr-xl tw-rounded-tl-xl tw-h-[80%] tw-bg-white",
                }}
                onEnd={onEnd}
            />
            <div className="tw-p-4 tw-flex tw-bg-white tw-w-full tw-justify-between">
                {/* Color Selection */}
                <div className="tw-flex tw-justify-start tw-gap-2 tw-mt-2">
                    {["#000000", "#10B981", "#1D4ED8"].map((color) => (
                        <button
                            key={color}
                            className={`tw-w-6 tw-h-6 tw-rounded-full tw-border-2 tw-transition-all tw-duration-200 ${
                                selectedColor === color
                                    ? "tw-border-gray-800 tw-scale-110 tw-shadow-md"
                                    : "tw-border-gray-300 hover:tw-border-gray-500"
                            }`}
                            style={{
                                backgroundColor: color,
                            }}
                            onClick={() => setSelectedColor(color)}
                            title={color === "#000000" ? "Black" : color === "#10B981" ? "Green" : "Blue"}
                        />
                    ))}
                </div>{" "}
                {/* Clear Button */}
                <button onClick={clearSignature} className="tw-mt-2  tw-px-3 tw-py-1 tw-rounded tw-text-sm">
                    Clear
                </button>
            </div>
        </div>
    );
};

export default SignaturePad;
